"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Icon from "./icon.js";
export const FingerprintIcon = React.forwardRef(function FingerprintIcon(props, ref) {
    return (_jsx(Icon, Object.assign({ ref: ref }, props, { children: _jsx("path", { d: "M7.864 4.243a7.5 7.5 0 0 1 7.688-.349A7.5 7.5 0 0 1 19.5 10.5a22.43 22.43 0 0 1-1.568 8.268M5.742 6.364C4.93 7.59 4.498 9.029 4.5 10.5c.002 1.413-.396 2.798-1.15 3.993m1.989 3.559A11.21 11.21 0 0 0 8.25 10.5 3.75 3.75 0 0 1 12 6.75a3.75 3.75 0 0 1 3.75 3.75l-.064 1.565M12 10.5a14.94 14.94 0 0 1-3.6 9.75m6.633-4.596c-.541 1.897-1.38 3.696-2.485 5.33" }) })));
});
export default FingerprintIcon;
//# sourceMappingURL=fingerprint.js.map